module.exports = __webpack_public_path__ + "prod/1.42.2/img/mogu-icon.566a6e17.png";